import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { Resetpassword, signup } from '../../api/api';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';
import img from '../../assets/660.png';
import { useAuth } from '../../context/AuthProvider';
import toast from 'react-hot-toast';

const  ResetPW = () => {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const {user} = useAuth()
  const navigate = useNavigate()

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    if (formData.newPassword !== formData.confirmPassword) {
      setError('Passwords do not match!');
      return;
    }
    try {
      const res = await Resetpassword(user?._id,formData);
      console.log(res);
      setFormData({
        newPassword: '',
        confirmPassword: ''
      });
      toast.success(res.message)
      navigate('/')
    } catch (error) {
      setError('An error occurred during signup.');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div className="flex flex-col h-screen lg:flex-row max-w-6xl items-center mx-auto justify-center p-4">
      {/* Image - visible on desktop, hidden on mobile */}
      <div className="hidden lg:block w-1/2 p-8 rounded-l-2xl">
        <img src={img} alt="Shoes" className="object-cover" />
      </div>

      {/* Form - takes full width on mobile, half width on desktop */}
      <div className="p-4 rounded-lg w-full lg:w-1/2">
        <h2 className="text-3xl font-bold text-center mb-6">This is your First login</h2>
        <p className="text-center text-gray-600 mb-8">Please change your password</p>
        
        {error && <p className="text-red-500 text-center">{error}</p>}
        
        <form onSubmit={handleSubmit}>
          {/* Password */}
          <div className="mb-4 flex relative">
            <input
              type={showPassword ? 'text' : 'password'}
              name="newPassword"
              placeholder="Enter your password"
              value={formData.newPassword}
              onChange={handleChange}
              className="w-full p-3 border-gray-400 border-b-2 focus:outline-none focus:border-black"
            />
            {showPassword ? (
              <RiEyeLine onClick={togglePasswordVisibility} className='absolute right-0 mt-5 cursor-pointer' />
            ) : (
              <RiEyeCloseLine onClick={togglePasswordVisibility} className='absolute right-0 mt-5 cursor-pointer' />
            )}
          </div>

          {/* Confirm Password */}
          <div className="mb-4 flex relative">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="Confirm your password"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="w-full p-3 border-gray-400 border-b-2 focus:outline-none focus:border-black"
            />
            {showConfirmPassword ? (
              <RiEyeLine onClick={toggleConfirmPasswordVisibility} className='absolute right-0 mt-5 cursor-pointer' />
            ) : (
              <RiEyeCloseLine onClick={toggleConfirmPasswordVisibility} className='absolute right-0 mt-5 cursor-pointer' />
            )}
          </div>

          <button type="submit" className="w-full mt-4 bg-black text-white p-3 rounded-3xl hover:bg-gray-800 transition">
            Reset Password
          </button>
        </form>

        <div className="text-center mt-4 text-gray-600 mt-20">
          Already have an account? <Link to='/'><span className='font-bold text-black hover:underline'>Login</span></Link>
        </div>
      </div>
    </div>
  );
};

export default  ResetPW;
